import { ClientRequest } from "@commercetools/sdk-client-v2"
import { withAuth } from "@jog/react-components"
import {
    JoggApiOption,
    addBillingAddressBase,
    addShippingAddressBase,
    applyGiftcardBase,
    buckarooCheckoutBase,
    buckarooGetOrderViewBase,
    cleanCostBase,
    client,
    getShippingMethodsBase,
    recalculateCartBase,
    removeGiftcardBase,
    removePaymentCostBase,
    replicateCartBase,
    replicateOrderBase,
    setPaymentCostBase,
    setShippingCostBase,
    validateCartBase,
    voucherApplyBase,
    voucherRemoveBase,
} from "@jog/shared"

const apiOption: JoggApiOption = {
    client,
    setToken: withAuth,
    execute: (request: ClientRequest) =>
        client.execute(request).catch((error) => {
            console.log(error)
            throw error
        }),
}

export const buckarooCheckout = buckarooCheckoutBase(apiOption)
export const buckarooGetOrderView = buckarooGetOrderViewBase(apiOption)
export const replicateCart = replicateCartBase(apiOption)
export const validateCart = validateCartBase(apiOption)
export const replicateOrder = replicateOrderBase(apiOption)
export const recalculateCart = recalculateCartBase(apiOption)
export const addBillingAddress = addBillingAddressBase(apiOption)
export const addShippingAddress = addShippingAddressBase(apiOption)
export const getShippingMethods = getShippingMethodsBase(apiOption)
export const setShippingCost = setShippingCostBase(apiOption)
export const applyGiftcard = applyGiftcardBase(apiOption)
export const removeGiftcard = removeGiftcardBase(apiOption)
export const setPaymentCost = setPaymentCostBase(apiOption)
export const removePaymentCost = removePaymentCostBase(apiOption)
export const voucherApply = voucherApplyBase(apiOption)
export const voucherRemove = voucherRemoveBase(apiOption)
export const cleanCost = cleanCostBase(apiOption)
